exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form .col-md-3[data-v-632775e5]{width:40%}#allSchemeAnalysisPage .table td[data-v-632775e5]{padding:5px 10px;white-space:nowrap}#allSchemeAnalysisPage .table thead th[data-v-632775e5]{white-space:nowrap}.analysis-sum-scheme-code[data-v-632775e5]{display:block;width:400px;word-wrap:break-word}.analysis-sum-scheme-code-date[data-v-632775e5]{display:block;width:62px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-632775e5","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/mutual-funds/all-scheme-analysis.vue
// module id = 647
// module chunks = 27